module.exports = __webpack_public_path__ + "static/media/knowledge-base-group.84062b59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings/knowledge-base-group.svg
// module id = T0+/
// module chunks = 89